import api from 'api/apiInstance';

export function clientCaseFinancialAuditsPrintApi(path: string) {
  return {
    path,
    GET: () => api.get(path),
  };
}
